export const DEFAULT_TOURNAMENTS = [
  {
    id: 1,
    title: "VSKturn Major: Counter-Strike 2",
    game: "Counter-Strike 2",
    date: "15 июня 2026",
    prize: "100 000 ₽",
    format: "5x5",
    status: "Регистрация открыта",
    level: "Любители / Semi-pro",
    image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=1200&q=80",
    teams: ["Neon Wolves", "Cyber Sharks", "Night Raid", "Pixel Hunters", "Red Falcons", "North Storm", "Aim Factory", "Vega Strike"],
    description: "Открытый турнир по Counter-Strike 2 для команд любого уровня подготовки с матчами до двух побед.",
  },
  {
    id: 2,
    title: "Dota Legends Battle",
    game: "Dota 2",
    date: "22 июня 2026",
    prize: "150 000 ₽",
    format: "5x5",
    status: "Регистрация открыта",
    level: "Командный турнир",
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=1200&q=80",
    teams: ["Ancient Five", "Roshan Guards", "Mid Lane Kings", "Dire Wolves", "Radiant Core", "Rune Hunters", "Black Lotus", "Aegis Squad"],
    description: "Киберспортивный турнир по Dota 2 с онлайн-трансляцией, судейством и призовым фондом.",
  },
  {
    id: 3,
    title: "Valorant Night Series",
    game: "Valorant",
    date: "30 июня 2026",
    prize: "75 000 ₽",
    format: "5x5",
    status: "Скоро",
    level: "Beginner / Semi-pro",
    image: "https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?auto=format&fit=crop&w=1200&q=80",
    teams: ["Spike Rush", "Phantom Crew", "One Tap Club", "Lotus Guard", "Icebox Five", "Pearl Attack", "Prime Agents", "Alpha Clutch"],
    description: "Вечерняя серия матчей по Valorant для начинающих и полупрофессиональных команд.",
  },
  {
    id: 4,
    title: "League Rift Cup",
    game: "League of Legends",
    date: "7 июля 2026",
    prize: "120 000 ₽",
    format: "5x5",
    status: "Регистрация открыта",
    level: "Открытая лига",
    image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=1200&q=80",
    teams: ["Rift Breakers", "Baron Control", "Nexus Rush", "Dragon Pit", "Blue Buffs", "Lane Masters", "Shadow Gank", "Team Eclipse"],
    description: "Командный турнир по League of Legends с групповой стадией и финальной сеткой плей-офф.",
  },
  {
    id: 5,
    title: "Fortnite Build Fight",
    game: "Fortnite",
    date: "14 июля 2026",
    prize: "60 000 ₽",
    format: "Duo",
    status: "Регистрация открыта",
    level: "Duo cup",
    image: "https://images.unsplash.com/photo-1600861194942-f883de0dfe96?auto=format&fit=crop&w=1200&q=80",
    teams: ["Sky Builders", "Storm Riders", "Zero Point", "Tilted Duo", "Zone Keepers", "High Ground", "Loot Lake", "Victory Pair"],
    description: "Динамичный турнир для дуо-команд: квалификация по очкам и финальная сетка лучших пар.",
  },
  {
    id: 6,
    title: "PUBG Battlegrounds League",
    game: "PUBG: Battlegrounds",
    date: "21 июля 2026",
    prize: "90 000 ₽",
    format: "Squad",
    status: "Скоро",
    level: "Squad league",
    image: "https://images.unsplash.com/photo-1616588589676-62b3bd4ff6d2?auto=format&fit=crop&w=1200&q=80",
    teams: ["Erangel Squad", "Miramar Kings", "Drop Zone", "Last Circle", "Blue Zone", "Red Smoke", "Vikendi Force", "Chicken Dinner"],
    description: "Турнир по PUBG для squad-составов с несколькими картами и зачётом по сумме очков.",
  },
  {
    id: 7,
    title: "Apex Arena Clash",
    game: "Apex Legends",
    date: "28 июля 2026",
    prize: "80 000 ₽",
    format: "3x3",
    status: "Регистрация открыта",
    level: "Arena / Trios",
    image: "https://images.unsplash.com/photo-1586182987320-4f17e2347b92?auto=format&fit=crop&w=1200&q=80",
    teams: ["Apex Predators", "Jump Masters", "Storm Point", "Olympus Team", "Kings Canyon", "Third Party", "Wingman Trio", "Red Shield"],
    description: "Серия матчей по Apex Legends для трио-команд с упором на командную тактику и агрессивную игру.",
  },
  {
    id: 8,
    title: "Rocket League Turbo Cup",
    game: "Rocket League",
    date: "4 августа 2026",
    prize: "50 000 ₽",
    format: "3x3",
    status: "Регистрация открыта",
    level: "3v3 cup",
    image: "https://images.unsplash.com/photo-1611996575749-79a3a250f948?auto=format&fit=crop&w=1200&q=80",
    teams: ["Turbo Boost", "Goal Rush", "Aerial Kings", "Orange Side", "Blue Side", "Flip Reset", "Overtime Crew", "Supersonic"],
    description: "Быстрый турнир по Rocket League с короткими матчами, плей-офф и финалом best of five.",
  },
  {
    id: 9,
    title: "Overwatch Control Point",
    game: "Overwatch 2",
    date: "11 августа 2026",
    prize: "70 000 ₽",
    format: "5x5",
    status: "Скоро",
    level: "Team fight",
    image: "https://images.unsplash.com/photo-1593305841991-05c297ba4575?auto=format&fit=crop&w=1200&q=80",
    teams: ["Payload Push", "Nano Boost", "Control Point", "Ult Economy", "Dive Squad", "Shield Break", "King Row", "Overtime Five"],
    description: "Командный турнир по Overwatch 2 с матчами на картах Control, Push и Hybrid.",
  },
  {
    id: 10,
    title: "EA FC Pro Weekend",
    game: "EA Sports FC 26",
    date: "18 августа 2026",
    prize: "40 000 ₽",
    format: "1x1",
    status: "Регистрация открыта",
    level: "Solo cup",
    image: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?auto=format&fit=crop&w=1200&q=80",
    teams: ["Final Whistle", "Goal Machine", "Penalty Pro", "Tiki Taka", "Golden Boot", "Clean Sheet", "High Press", "Extra Time"],
    description: "Соревнование по EA Sports FC для одиночных игроков: быстрые матчи и финальная сетка на выбывание.",
  },
  {
    id: 11,
    title: "Mobile Legends Community Cup",
    game: "Mobile Legends: Bang Bang",
    date: "25 августа 2026",
    prize: "65 000 ₽",
    format: "5x5",
    status: "Регистрация открыта",
    level: "Mobile esports",
    image: "https://images.unsplash.com/photo-1598550476439-6847785fcea6?auto=format&fit=crop&w=1200&q=80",
    teams: ["Legend Five", "Turtle Control", "Lord Hunters", "Gold Lane", "Mid Core", "Savage Squad", "Crystal Push", "Mythic Team"],
    description: "Мобильный турнир для команд Mobile Legends с регистрацией составов и сеткой плей-офф.",
  },
  {
    id: 12,
    title: "Rainbow Six Tactical Cup",
    game: "Rainbow Six Siege",
    date: "1 сентября 2026",
    prize: "85 000 ₽",
    format: "5x5",
    status: "Скоро",
    level: "Tactical cup",
    image: "https://images.unsplash.com/photo-1509198397868-475647b2a1e5?auto=format&fit=crop&w=1200&q=80",
    teams: ["Breach Team", "Defuse Point", "Reinforced Wall", "Operator Five", "Drone Check", "Clutch Room", "Tactical Entry", "Black Ice"],
    description: "Тактический турнир по Rainbow Six Siege для команд, которые готовы играть по правилам плей-офф.",
  },
  {
    id: 13,
    title: "Minecraft Bed Wars Clash",
    game: "Minecraft",
    date: "8 сентября 2026",
    prize: "35 000 ₽",
    format: "4x4",
    status: "Регистрация открыта",
    level: "Community cup",
    image: "https://images.unsplash.com/photo-1593640495253-23196b27a87f?auto=format&fit=crop&w=1200&q=80",
    teams: ["Block Rush", "Diamond Base", "Red Bed", "Emerald Mid", "Sky Bridge", "Void Walkers", "Craft Kings", "Obsidian Wall"],
    description: "Командный турнир по Minecraft Bed Wars с быстрыми матчами и сеткой на выбывание.",
  },
  {
    id: 14,
    title: "Warzone Drop Cup",
    game: "Call of Duty: Warzone",
    date: "15 сентября 2026",
    prize: "95 000 ₽",
    format: "Trio",
    status: "Регистрация открыта",
    level: "Battle royale",
    image: "https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?auto=format&fit=crop&w=1200&q=80",
    teams: ["Gulag Kings", "Loadout Trio", "Final Circle", "Recon Squad", "Airstrike", "Downtown Team", "Armor Plates", "Drop Leaders"],
    description: "Турнир по Warzone для трио с подсчётом очков за фраги, выживание и итоговое место.",
  },
  {
    id: 15,
    title: "Hearthstone Masters Night",
    game: "Hearthstone",
    date: "22 сентября 2026",
    prize: "30 000 ₽",
    format: "1x1",
    status: "Скоро",
    level: "Card battle",
    image: "https://images.unsplash.com/photo-1606167668584-78701c57f13d?auto=format&fit=crop&w=1200&q=80",
    teams: ["Mana Curve", "Legend Rank", "Control Deck", "Aggro Line", "Top Deck", "Golden Card", "Lethal Setup", "Arena Mind"],
    description: "Карточный турнир для одиночных игроков с матчами best of three и финалом best of five.",
  },
  {
    id: 16,
    title: "Tekken Fight Night",
    game: "Tekken 8",
    date: "29 сентября 2026",
    prize: "45 000 ₽",
    format: "1x1",
    status: "Регистрация открыта",
    level: "Fighting",
    image: "https://images.unsplash.com/photo-1511882150382-421056c89033?auto=format&fit=crop&w=1200&q=80",
    teams: ["Iron Fist", "Perfect Round", "Rage Art", "Combo Lab", "King Move", "Low Parry", "Final Round", "Arcade Hero"],
    description: "Файтинг-турнир по Tekken 8 с классической сеткой плей-офф и матчами до трёх побед.",
  },
];
